var _rect, _path, _path2, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.265625,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#010304"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3032 17.0422C30.6521 14.6121 29.2173 12.4649 27.2215 10.9334C25.2256 9.40189 22.7801 8.57178 20.2644 8.57178C17.7487 8.57178 15.3032 9.40189 13.3073 10.9334C11.3115 12.4649 9.87671 14.6121 9.22559 17.0422L12.5372 17.9295C12.993 16.2285 13.9973 14.7254 15.3945 13.6534C16.7916 12.5813 18.5034 12.0002 20.2644 12.0002C22.0254 12.0002 23.7372 12.5813 25.1343 13.6534C26.5314 14.7254 27.5358 16.2285 27.9916 17.9295L31.3032 17.0422Z",
    fill: "#26DDF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22609 22.9444C9.87721 25.3744 11.312 27.5217 13.3078 29.0532C15.3037 30.5847 17.7492 31.4148 20.2649 31.4148C22.7806 31.4148 25.2261 30.5847 27.222 29.0532C29.2178 27.5217 30.6526 25.3744 31.3037 22.9444L27.9921 22.0571C27.5363 23.7581 26.532 25.2612 25.1348 26.3332C23.7377 27.4052 22.0259 27.9863 20.2649 27.9863C18.5039 27.9863 16.7921 27.4052 15.395 26.3332C13.9978 25.2612 12.9935 23.7581 12.5377 22.0571L9.22609 22.9444Z",
    fill: "#26DDF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6934,
    y: 18.3225,
    width: 9.14257,
    height: 3.42847,
    fill: "#26DDF9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5498,
    y: 5.14331,
    width: 3.42847,
    height: 29.7134,
    fill: "#26DDF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiku);
export default __webpack_public_path__ + "static/media/piku.0c7c1af038d7c4a72bf2152a86c664c8.svg";
export { ForwardRef as ReactComponent };